export default (that) => [

  {
    title: that.$l('table_scm_name') || '工厂',
    field: 'scmName',
    minWidth: 150,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string'
  },
  {
    title: that.$l('table_shipmentRate') || '出货率',
    field: 'shipmentRate',
    minWidth: 150,
    headerAlign: 'left',
    align: 'left',
    sortable: true,
    sortType: 'number',
    slots: {
      default: 'shipmentRate',
      header: 'shipmentRateHeader',
    }
  },
  {
    title: that.$l('table_quantity') || '已出货票数',
    field: 'quantity',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number'
  },
  {
    title: that.$l('table_total_quantity') || '总出货票数',
    field: 'totalQuantity',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number'
  },
  {
    title: that.$l('table_total_price') || '出货金额',
    field: 'totalSalePrice',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
    slots: { default: 'totalSalePrice' }
  },

]
